export const authConsts = {
  LOGIN_REQUEST: "LOGIN_REQUEST",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  LOGIN_FAILURE: "LOGIN_FAILURE",

  SIGNUP_REQUEST: "SIGNUP_REQUEST",
  SIGNUP_SUCCESS: "SIGNUP_SUCCESS",
  SIGNUP_FAILURE: "SIGNUP_FAILURE",

  CONFIRM_EMAIL_REQUEST: "CONFIRM_EMAIL_REQUEST",
  CONFIRM_EMAIL_SUCCESS: "CONFIRM_EMAIL_SUCCESS",
  CONFIRM_EMAIL_FAILURE: "CONFIRM_EMAIL_FAILURE",

  GET_PERSONAL_DATA_REQUEST: "GET_PERSONAL_DATA_REQUEST",
  GET_PERSONAL_DATA_SUCCESS: "GET_PERSONAL_DATA_SUCCESS",
  GET_PERSONAL_DATA_FAILURE: "GET_PERSONAL_DATA_FAILURE",

  CHANGE_PERSONAL_DATA_REQUEST: "CHANGE_PERSONAL_DATA_REQUEST",
  CHANGE_PERSONAL_DATA_SUCCESS: "CHANGE_PERSONAL_DATA_SUCCESS",
  CHANGE_PERSONAL_DATA_FAILURE: "CHANGE_PERSONAL_DATA_FAILURE",

  RESEND_CONFIRMATION_EMAIL_REQUEST: "RESEND_CONFIRMATION_EMAIL_REQUEST",
  RESEND_CONFIRMATION_EMAIL_SUCCESS: "RESEND_CONFIRMATION_EMAIL_SUCCESS",
  RESEND_CONFIRMATION_EMAIL_FAILURE: "RESEND_CONFIRMATION_EMAIL_FAILURE",

  GET_SESSION_DATA_REQUEST: "GET_SESSION_DATA_REQUEST",
  GET_SESSION_DATA_SUCCESS: "GET_SESSION_DATA_SUCCESS",
  GET_SESSION_DATA_FAILURE: "GET_SESSION_DATA_FAILURE",

  CHANGE_PSWD_REQUEST: "CHANGE_PSWD_REQUEST",
  CHANGE_PSWD_SUCCESS: "CHANGE_PSWD_SUCCESS",
  CHANGE_PSWD_FAILURE: "CHANGE_PSWD_FAILURE",

  RESET_PSWD_SEND_EMAIL_REQUEST: "RESET_PSWD_SEND_EMAIL_REQUEST",
  RESET_PSWD_SEND_EMAIL_SUCCESS: "RESET_PSWD_SEND_EMAIL_SUCCESS",
  RESET_PSWD_SEND_EMAIL_FAILURE: "RESET_PSWD_SEND_EMAIL_FAILURE",

  RESET_PSWD_REQUEST: "RESET_PSWD_REQUEST",
  RESET_PSWD_SUCCESS: "RESET_PSWD_SUCCESS",
  RESET_PSWD_FAILURE: "RESET_PSWD_FAILURE",

  DELETE_ACCOUNT_REQUEST: "DELETE_ACCOUNT_REQUEST",
  DELETE_ACCOUNT_SUCCESS: "DELETE_ACCOUNT_SUCCESS",
  DELETE_ACCOUNT_FAILURE: "DELETE_ACCOUNT_FAILURE",

  LOGOUT: "LOGOUT",
  CLEAR_ERROR: "CLEAR_ERROR",
  CLEAR_ACCOUNT_ACTN_STATE: "CLEAR_ACCOUNT_ACTN_STATE",
  SESSION_ERROR: "SESSION_ERROR",
};

export interface AuthAction {
  type: string;
  user: string;
  userId: string;
  error: string;
  sesja: DaneSesji;
}

export interface DaneOsobiste {
  Imie: string;
  Nazwisko: string;
}

export interface DaneSesji {
  EmailPotwierdzony: boolean;
  Token: string;
}

export interface TokenInfo {
  CzyMaDostep: boolean;
  Token: string;
}

export enum AccountActionsState {
  Initialized = "Initialized",
  ResetPswdMailSent = "ResetPswdMailSent",
  ResetPswdSuccess = "ResetPswdSuccess",
  ConfirmEmailSuccess = "ConfirmEmailSuccess",
}

export interface IParams {
  product: string;
  host: string;
  redirect: string;
  idorganizacji: string;
  idzaproszenia: string;
}
